import { call, put, select } from 'redux-saga/effects'
import { takeEvery } from 'redux-saga'
import fitBounds from 'helpers/map/fitBounds'
import extractBoundsFromCameras from 'helpers/cameras/extractBounds'
import { zoomToAllDevicesSelector } from 'selectors'
import { ZOOM_TO_SINGLE_CAMERA } from 'actions/mapTypes'
import { notifyHoneybadgerAction } from 'actions/applicationActions'

export const getMaxZoomLevelForLatLng = (maxZoomService, latLng) =>
  new Promise(resolve => {
    maxZoomService.getMaxZoomAtLatLng(latLng, resp => {
      if (resp.status === 'OK') resolve(resp)
      else resolve({ error: resp })
    })
  })

export function * zoomToSingleCamera(action) {
  try {
    const { cameras, map: { ref } } = yield select(zoomToAllDevicesSelector)
    const { camera, checkMaxZoom } = yield action

    if (EXPORT && checkMaxZoom) {
      const { zoom, error } = yield call(getMaxZoomLevelForLatLng, new google.maps.MaxZoomService(), camera.location)
      if (zoom) ref.setOptions({ maxZoom: zoom })
      else if (error) console.warn(error)
    } else if (EXPORT && !checkMaxZoom) {
      ref.setOptions({ maxZoom: null })
    }

    const filteredCameras = camera.isMultiImager ? cameras.filter(c => camera.lensIds.includes(c.id)) : [camera]
    const bounds = yield call(extractBoundsFromCameras, { cameras: filteredCameras })
    yield call(fitBounds, { ref, bounds })
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function * watchZoomToSingleCamera() {
  yield * takeEvery(ZOOM_TO_SINGLE_CAMERA, zoomToSingleCamera)
}



// WEBPACK FOOTER //
// ./src/sagas/zoomToSingleCameraSaga.js